export default {
  initializeHook() {
    $('html').addClass('outlookWrap')

    // set target="_blank" on all footer links so that iframe flow does not break
    $('#footer a').attr('target', '_blank')
  },
}
